import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import ProgressSkeleton from 'components/layout/ProgressSkeleton';
import { useMeOptions } from '../../features/users';
import { useQuery } from '@tanstack/react-query';
import { useInitialProject } from '../../features/projects';
import datadogActions, { trackUserSession, trackUrlSessionView } from 'lib/datadog';

const AuthRequired = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const { route } = useAuthenticator((context) => [context.route]);
  const { data: me, isFetching, isFetched } = useQuery(useMeOptions);

  useInitialProject();

  useEffect(() => {
    if (me) {
      datadogActions.setDatadogUser({ id: me.id, email: me.email, role: me.role });
      trackUserSession(me.id);
    }
  }, [me]);

  useEffect(() => {
    trackUrlSessionView(location.pathname);
  }, [location.pathname]);

  if (route === 'idle' || isFetching) {
    return <ProgressSkeleton />;
  }

  if (route !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (isFetched && (!me?.role || (me?.role === 'user' && !me?.projects.length))) {
    return <Navigate to="/forbidden" />;
  }

  return children;
};
export default AuthRequired;
